export const achievementData = {
    bio: "Success is not final; failure is not fatal: It is the courage to continue that counts — Winston S. Churchill ",
    achievements: [
        {
            id: 1,
            title: 'Black Belt Web Developer',
            details: 'This course was about web development. HTML, CSS, BootStrap, Tailwind, daisyUI, JavaScript, React, MongoDB, NodeJs, ExpressJs, Firebase, Git etc were taught in this course. ',
            date: 'June 5, 2022',
            field: 'Web_Development',
            image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/black%20belt.jpg'
        },
        {
            id: 2,
            title: 'Complete Web Development Course with Jhankar Mahbub',
            details: 'This course was about web development. HTML, CSS, BootStrap, Tailwind, daisyUI, JavaScript, React, MongoDB, NodeJs, ExpressJs, Firebase, Git etc were taught in this course. ',
            date: 'June 5, 2022',
            field: 'Web_Development',
            image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/certificatephero.jpg'
        },
        {
            id: 3,
            title: 'Associate Member',
            details: 'Bangladesh Computer Society, Dhaka.',
            date: 'March 1, 2022',
            field: 'Activities',
            image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/bcs.png'

        },
        {
            id: 4,
            title: 'Treasurer',
            details: 'Club for Updated Search on Computer (CLUSTER), Khulna University.',
            date: 'February 1, 2021',
            field: 'Activities',
            image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/cluster.jpg'
        },
        {
            id: 5,
            title: 'Founder',
            details: 'Colonbil Village Food. An Online Food Items Shop.',
            date: 'February 1, 2022',
            field: 'Activities',
            image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/cvf.png'

        },


    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/